<template>
    <seccion-datos titulo="Especialidades ELBA" :botonGuardar="false" tipo="info">
        <div class="row">
            <div class="col-md-12">
                <p class="text-muted">
                    Equivalencia entre las categorías de ELBA y las especialidades de PWGS.
                    <!-- Sin ella, los trabajos que lleguen de ELBA no se pueden importar. -->
                </p>
                <button type="button" class="btn btn-light" style="width:fit-content; border: 1px solid grey;"
                        @click="abrir()">
                    Configurar equivalencias
                </button>
            </div>
        </div>
                <Dialog modal
                header="Equivalencias de especialidades con ELBA"
                v-model:visible="visible"
                :style="{ width: '50rem' }">

            <div v-if="error" class="alert alert-danger" style="padding:8px">{{ error }}</div>

            <!-- Alta -->
            <div class="row" style="margin-bottom:15px">
                <div class="col-md-5">
                    <label>Categoría ELBA</label>
                    <Dropdown v-model="categoriaSel"
                              :options="categoriasEtiquetadas"
                              optionLabel="etiqueta"
                              optionValue="categoria_elba"
                              filter
                              :placeholder="categorias.length ? 'Selecciona una categoría' : 'No hay categorías disponibles'"
                              :disabled="!categorias.length"
                              class="w-100" />
                </div>
                <div class="col-md-5">
                    <label>Especialidad PWGS</label>
                    <Dropdown v-model="especialidadSel"
                              :options="especialidades"
                              optionLabel="nombre"
                              optionValue="idespecialidad"
                              filter
                              placeholder="Selecciona una especialidad"
                              class="w-100" />
                </div>
                <div class="col-md-2" style="padding-top:23px">
                    <button type="button" class="btn btn-primary btn-sm"
                            :disabled="guardando || !especialidadSel || !categoriaSel"
                            @click="añadirEquivalencia()">
                        Añadir
                    </button>
                </div>
            </div>

            <p v-if="!cargando && !categorias.length && !relaciones.length" class="text-muted">
                No hay categorías de ELBA cargadas para esta compañía. 
            </p>

            <!-- Equivalencias ya añadidas -->
            <table class="table table-condensed table-striped" v-if="relaciones.length">
                <thead>
                    <tr>
                        <th>Categoría ELBA</th>
                        <th>Especialidad PWGS</th>
                        <th style="width:60px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="rel in relaciones" :key="rel.id">
                        <td>
                            <span class="label label-default">{{ rel.categoria_elba }}</span>
                            {{ rel.nombre_categoria || '—' }}
                        </td>
                        <td>{{ rel.nombre_especialidad || '—' }}</td>
                        <td>
                            <button type="button" class="btn btn-danger btn-xs"
                                    :disabled="guardando"
                                    @click="eliminarEquivalencia(rel.id)">
                                Eliminar
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p v-else-if="!cargando" class="text-muted">Todavía no hay equivalencias añadidas.</p>
            <p v-if="cargando" class="text-muted">Cargando...</p>

            <div style="margin-top:15px">
                <button type="button" class="btn btn-sm btn-default" @click="visible=false">Cerrar</button>
            </div>
        </Dialog>
    </seccion-datos>
</template>

<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';

export default {
    components: { Dialog, Dropdown },
    props: {
        datos: {
            type: Object
        },
        id: {
            default: 0,
        }
    },
    data() {
        return {
            visible: false,
            cargando: false,
            guardando: false,
            error: '',
            relaciones: [],
            especialidades: [],
            categorias: [],
            especialidadSel: 0,
            categoriaSel: 0,
        };
    },
    methods: {
        abrir() {
            this.visible = true;
            this.cargar();
        },
        /* Una sola llamada: el endpoint devuelve la tabla y los dos selectores.
           Las categorías vienen ya filtradas por el usuario de ELBA de esta
           compañía y sin las que ya están asignadas. */
        async cargar() {
            this.cargando = true;
            this.error = '';
            try {
                const api = new PwgsApi();
                const resp = await api.get('companias/' + this.id + '/especialidades-elba');
                this.relaciones = resp.datos || [];
                this.especialidades = resp.especialidades || [];
                this.categorias = resp.categorias || [];
            } catch (e) {
                this.error = 'No se han podido cargar las equivalencias.';
            }
            this.cargando = false;
        },
        async añadirEquivalencia() {
            if (!this.especialidadSel || this.especialidadSel == 0 || !this.categoriaSel || this.categoriaSel == 0) {
                this.error = 'Selecciona una categoría y una especialidad.';
                return;
            }
            this.guardando = true;
            this.error = '';
            try {
                const api = new PwgsApi();
                await api.post('companias/' + this.id + '/especialidades-elba', {
                    especialidades_idespecialidad: this.especialidadSel,
                    categoria_elba: this.categoriaSel
                });
                this.especialidadSel = 0;
                this.categoriaSel = 0;
                await this.cargar();
            } catch (e) {
                this.error = 'No se ha podido añadir la equivalencia.';
            }
            this.guardando = false;
        },
        async eliminarEquivalencia(idRelacion) {
            
            this.guardando = true;
            this.error = '';
            try {
                const api = new PwgsApi();
                await api.delete('companias/' + this.id + '/especialidades-elba/' + idRelacion);
                await this.cargar();
            } catch (e) {
                this.error = 'No se ha podido eliminar la equivalencia.';
            }
            this.guardando = false;
        }
    },
    computed: {
        categoriasEtiquetadas() {
            return this.categorias.map(c => ({
                ...c,
                etiqueta: c.categoria_elba + ' - ' + c.nombre_categoria
            }));
        }
    }
}
</script>